import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { AYEN_SERVICES_ENDPOINTS } from '../../api/endpoints/ayen-services.endpoints';

@Injectable({
  providedIn: 'root',
})
export class AyenServices {
  private api = inject(ApiService);

  getAyenServices(): Observable<any> {
    return this.api.get(AYEN_SERVICES_ENDPOINTS.V1.AYEN_SERVICES);
  }
}
